
import React from 'react';

const EmptyScheduleMessage: React.FC = () => {
  return (
    <div className="text-center py-6 text-gray-500 dark:text-gray-400">
      No schedules yet. Add a schedule to automate this load.
    </div>
  );
};

export default EmptyScheduleMessage;
